import { jsx as n, jsxs as b } from "react/jsx-runtime";
import p from "react";
import i, { css as e } from "styled-components";
import { m as c } from "./breakpoints.907eaecd.js";
import { RangoButton as C, ButtonSize as N } from "../es/Button.js";
import { RangoButtonMini as T } from "../es/ButtonMini.js";
import { RangoButtonGroup as w, RangoButtonGroupItem as B, ButtonGroupItemVariant as R } from "../es/ButtonGroup.js";
const y = i.div.withConfig({
  displayName: "FixedBar",
  componentId: "sc-1cglcg8-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:100%;box-sizing:border-box;height:var(--size-12x);background:var(--elements-bg-color-02);gap:var(--spacing-4x);padding:0 var(--spacing-5x);", ""], c.sm(e(["gap:var(--spacing-2x);padding:0 var(--spacing-3x);"]))), v = i.div.withConfig({
  displayName: "SlotAction",
  componentId: "sc-1cglcg8-1"
})(["margin-left:auto;", ""], c.sm(e(["width:100%;"]))), O = i(C).withConfig({
  displayName: "Button",
  componentId: "sc-1cglcg8-2"
})(["", ""], c.sm(e(["width:100%;"]))), U = i(T).withConfig({
  displayName: "CancelButton",
  componentId: "sc-1cglcg8-3"
})(["", ""], c.sm(e(["width:100%;"]))), o = {
  BUTTON: "button",
  BUTTON_GROUP: "button-group",
  CANCEL_BUTTON: "cancel-button"
}, k = p.forwardRef(({
  action: f = o.BUTTON,
  labelButtonConfirm: r = "",
  labelButtonCancel: d = "",
  onConfirm: s,
  onCancel: g,
  propsButton: l,
  propsButtonGroup: G,
  className: x,
  ...t
}, h) => {
  var m, u;
  let a;
  switch (f) {
    case o.BUTTON:
      a = /* @__PURE__ */ n(O, { ...l, size: N.LG, onClick: s, ...t.dataButtonConfirm, children: r });
      break;
    case o.BUTTON_GROUP:
      a = /* @__PURE__ */ b(w, { children: [
        /* @__PURE__ */ n(B, { slot: "primary", onClick: s, ...(m = t == null ? void 0 : t.dataButtonConfirm) == null ? void 0 : m.buttonProps, children: r }),
        /* @__PURE__ */ n(B, { slot: "secondary", variant: R.Mini, onClick: g, ...(u = t == null ? void 0 : t.dataButtonCancel) == null ? void 0 : u.buttonProps, children: d })
      ] });
      break;
    case o.CANCEL_BUTTON:
      a = /* @__PURE__ */ n(U, { ...l, onClick: g, ...t.dataButtonCancel, children: d });
      break;
    default:
      a = null;
  }
  return /* @__PURE__ */ n(y, { className: x, ref: h, "data-testid": "rango-fixed-bar", "data-rango-component": "rango-fixed-bar", "data-is-rango": !0, children: /* @__PURE__ */ n(v, { children: a }) });
});
k.displayName = "RangoFixedBar";
export {
  k as R,
  o as a
};
